export default __webpack_public_path__ + "static/media/google2.58d20b81.jpg";